import { render, staticRenderFns } from "./DelPerson.vue?vue&type=template&id=03194f9c&scoped=true"
import script from "./DelPerson.vue?vue&type=script&lang=js"
export * from "./DelPerson.vue?vue&type=script&lang=js"
import style0 from "./DelPerson.vue?vue&type=style&index=0&id=03194f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03194f9c",
  null
  
)

export default component.exports